var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAUp5Vector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 28,
    viewBox: "0 0 261 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.991 26C151.451 18.5373 118.476 22.5866 88.5886 23.272C79.9946 23.4693 71.2019 24.7846 62.6163 24.2214C61.4965 24.1482 56.6109 23.8737 55.6945 22.4071C55.5748 22.2162 59.3845 21.4636 61.2353 21.1417C64.8341 20.5157 68.4313 20.0539 72.0271 19.3927C81.4806 17.6556 91.0994 16.8081 100.636 16.0273C125.116 14.0247 168.908 7.85302 192.833 16.5564C194.018 16.9876 190.354 16.4822 189.114 16.4422C187.077 16.3769 185.041 16.2824 183.004 16.2068C176.359 15.961 169.658 15.5239 163.012 15.5926C141.595 15.8127 120.103 14.7555 98.6916 15.7024C92.2489 15.9877 85.8268 16.5801 79.3812 16.8091C75.6477 16.9416 75.815 17.0538 71.9563 16.8991C70.2833 16.8318 65.6443 17.4267 66.9675 16.2147C69.2979 14.0795 76.5817 14.6136 79.3988 14.1779C92.2615 12.1911 105.092 9.59655 118.021 8.2026C151.17 4.62849 184.917 4.62008 218.142 6.11539C231.734 6.72706 245.466 4.361 259 6.27266C226.162 1.26109 192.029 1.97264 159.011 2.11752C121.835 2.2807 84.7016 2.29158 47.5252 3.21725C32.263 3.59701 17.3087 7.03158 2 6.78088",
    stroke: "url(#paint0_linear_1660_1735)",
    strokeWidth: 3.05,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1660_1735",
    x1: 1.99918,
    y1: 13.9972,
    x2: 259,
    y2: 13.9972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAUp5Vector1);
export default __webpack_public_path__ + "static/media/aUP5Vector1.29ef6ed645e086640225d51232544559.svg";
export { ForwardRef as ReactComponent };